import './styles/gov-incentives.scss';

import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import React from 'react';
import SEO from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Seo';
import { TitleBanner } from '../components/Primitives';
import { graphql } from 'gatsby';
import useMobileDetect from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Hooks/useMobileDetect';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';

export const query = graphql`
    query {
        incentives: allProductsJson(
            filter: { category: { eq: "/Drolet/CMS/Government incentives/" } }
        ) {
            nodes {
                category
                code
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                documents {
                    en_CA
                    en_US
                    fr_CA
                    caption {
                        en_CA
                        en_US
                        fr_CA
                    }
                }
                attributes {
                    available_country {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    url {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
        metadata: allProductsJson(
            filter: { code: { eq: "drolet_incitatifs-gov" } }
        ) {
            nodes {
                code
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                fields {
                    banniere_desktop {
                        childImageSharp {
                            gatsbyImageData(layout: CONSTRAINED)
                        }
                    }
                    banniere_mobile {
                        childImageSharp {
                            gatsbyImageData(layout: CONSTRAINED)
                        }
                    }
                }
                description {
                    en_CA
                    en_US
                    fr_CA
                }
                attributes {
                    meta_title {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_description {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
    }
`;

export default function GovernmentIncentives({ data }) {
    const { currentLocale } = usePageLocalization();
    const incentives = data.incentives.nodes;
    const metadata = data.metadata.nodes[0].attributes;
    const title = data.metadata.nodes[0].title[currentLocale];
    const description = data.metadata.nodes[0].description[currentLocale];
    const responsiveImages = data?.metadata?.nodes?.[0]?.fields;
    const isMobile = useMobileDetect().isMobile();
    const desktopImage =
        responsiveImages?.banniere_desktop[0]?.childImageSharp
            ?.gatsbyImageData;
    const mobileImage =
        responsiveImages?.banniere_mobile[0]?.childImageSharp
            ?.gatsbyImageData;

    return (
        <Layout>
            <SEO
                title={metadata.meta_title.values[0][currentLocale]}
                description={metadata.meta_description.values[0][currentLocale]}
            />
            <TitleBanner
                imageData={isMobile ? mobileImage : desktopImage}
                title={title}
            />
            <div className='container gov-incentives'>
                <h4>{description}</h4>
                <ul>
                    {incentives.map((incentive) => {
                        const current_country =
                            currentLocale.split('_')[1] === 'CA'
                                ? 'Canada'
                                : 'United States';
                        const incentive_title = incentive?.title[currentLocale];
                        const incentive_country =
                            incentive?.attributes?.available_country
                                ?.values?.[0].en_CA;
                        const url =
                            incentive?.attributes?.url?.values?.[0]?.[
                                currentLocale
                            ];

                        const fileUrl =
                            '/file/' +
                            incentive?.documents?.[0]?.[currentLocale];

                        return current_country === incentive_country ? (
                            <li key={incentive.code}>
                                <a
                                    href={url ? url : fileUrl}
                                    target='_blank'
                                    rel='noreferrer'
                                    title={incentive?.title[currentLocale]}
                                >
                                    {incentive_title}
                                </a>
                            </li>
                        ) : undefined;
                    })}
                </ul>
            </div>
        </Layout>
    );
}
